module.exports = __webpack_public_path__ + "static/media/ring.5187be72.svg";